(function(){
'use strict';

angular.module('classy.frs.donation').controller('frs-donationCheckoutCtrl', ["$scope", function ($scope) {
  $scope.page = $scope.theme.pages.donation;
}]);
})();